/**
 * 商品の自動読み込み
 */
function getNextUrl($collectionPagination) {
    let nextUrl = null;

    const $next = $collectionPagination.getElementsByClassName('pagination-custom__next');
    if($next.length) {
        nextUrl = $next[0].getAttribute('href');
    }

    return nextUrl;
}

function addCollectionItemsIdNeeded($collectionPagination) {
    const nextUrl = getNextUrl($collectionPagination);

    if (nextUrl) {
        const $productsGrid = document.getElementById('productsGrid');
        $productsGrid.classList.add('is-loading');

        fetch(nextUrl)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const newDocument = parser.parseFromString(html, 'text/html');
                const $newItems = newDocument.querySelectorAll('.grid-item.product-item');

                if ($newItems.length) {
                    const $collectionLoop = document.getElementById('CollectionLoop');
                    $newItems.forEach(item => {
                        $collectionLoop.appendChild(item);
                    });

                    const $newPagination = newDocument.getElementById('collectionPagination');
                    const $pagination = document.getElementById('collectionPagination');
                    $pagination.innerHTML = $newPagination.innerHTML;
                }
            })
            .catch(error => console.error("Error fetching next page:", error))
            .finally(() => {
                $productsGrid.classList.remove('is-loading');
            });
    }
}

function initAutoLoadItemsEvent() {
    const $collectionPagination = document.getElementById('collectionPagination');
    if ($collectionPagination) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const $newCollectionPagination = document.getElementById('collectionPagination');

                    if($newCollectionPagination) {
                        addCollectionItemsIdNeeded($newCollectionPagination);
                    }
                }
            });
        });
        observer.observe($collectionPagination);
    }
}
initAutoLoadItemsEvent();